import endPoints from 'utils/endPoints';
import { PostMutate, PutMutate } from 'utils/mutationAndQuery/customMutation';
import { FetchAllData } from 'utils/mutationAndQuery/customUseQuery';

export const fetchCurrencies = (options?: { enabled?: boolean }) => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.fetchUserCurrencies,
    enabled: options?.enabled,
  });
  return {
    isLoading,
    currencies: data?.data ?? [],
    enableCurrencyExchange: data?.enable_currency_exchange ?? false,
    message: data?.message,
    isSuccess,
  };
};

export const fetchAllCurrencies = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.fetchAllCurrency,
  });
  return {
    isLoading,
    allCurrencies: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const manageDefaultCurrency = () => {
  const { data, isPending, isSuccess, mutate, message, isError, clearData } =
    PutMutate(endPoints.setDefaultCurrency, endPoints.fetchUserCurrencies);

  return {
    loading: isPending,
    updateUserCurrency: data?.data ?? [],
    message: message,
    isSuccess,
    isError,
    mutate,
    clearData,
  };
};

export const addCurrency = () => {
  const { data, isPending, isSuccess, mutate, message, isError, clearData } =
    PostMutate(endPoints.addCurrency, endPoints.fetchUserCurrencies);

  return {
    loading: isPending,
    addedCurrency: data?.data ?? [],
    message: message,
    isSuccess,
    isError,
    mutate,
    clearData,
  };
};

export const toggleCurrencyExchange = () => {
  const { data, isPending, isSuccess, mutate, message, isError, clearData } =
    PutMutate(endPoints.toggleCurrencyExchange, endPoints.fetchUserCurrencies);

  return {
    loading: isPending,
    toggleResult: data?.data ?? [],
    message: message,
    isSuccess,
    isError,
    mutate,
    clearData,
  };
};
